import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../common/html/element'
import { Icon } from '../common/html/icon'
import { Image } from '../common/image'
import { Loading } from '../common/loading'
import EventEmitter, {
  DISABLE_FOOTER,
  SCROLL_DISABLE,
} from '../helpers/EventEmitter'
import { debounce, sortByProp } from '../helpers/common'
import { getInnerHeight, getInnerWidth } from '../helpers/device'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../layout/LayoutContainer'
import './i18n'
import classes from './index.module.scss'
import service from './store/Service'

export const Content = ({ headRef, id, children, data, setData }) => {
  const location = useLocation()

  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingImg, setIsLoadingImg] = useState(true)
  const [currentImg, setCurrentImg] = useState(0)
  const [top, setTop] = useState(0)
  const [size, setSize] = useState({
    width: getInnerWidth(),
    height: getInnerHeight(),
  })

  const locale = useSelector((state) => state.i18n.locale)
  const screenUrl = id || location.pathname

  useEffect(() => {
    reCallAPI(false)
  }, [screenUrl])

  useEffect(() => {
    if (!!data.length) {
      EventEmitter.dispatch(DISABLE_FOOTER, { isShow: false })
    }

    return () => {
      EventEmitter.dispatch(DISABLE_FOOTER, { isShow: true })
    }
  }, [screenUrl, data])

  useEffect(() => {
    reCallAPI(true)
  }, [locale])

  const reCallAPI = (isChangeLocale) => {
    if (isChangeLocale && !data.length) {
      return
    }

    if (data.length) {
      setIsLoading(true)
      setData([])
    }

    service
      .getCoachMarks({ screenUrl })
      .then((res) => {
        setIsLoading(false)
        setCurrentImg(0)
        if (res.data.length) {
          setData(sortByProp(res.data, 'order', false))
          EventEmitter.dispatch(SCROLL_DISABLE, {
            id: SCROLL_LAYOUT_ELEMENT_ID,
            disable: true,
          })
        }
      })
      .catch(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    if (headRef) {
      setTop(headRef.current?.clientHeight || 0)
    }

    const resize = debounce(() => {
      if (headRef) {
        setTop(headRef.current?.clientHeight || 0)
      }
      setSize({
        width: getInnerWidth(),
        height: getInnerHeight(),
      })
    })

    window.addEventListener('resize', resize)
    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  useEffect(() => {
    const LEFT_ARROW = 37
    const RIGHT_ARROW = 39

    const keyDown = (e) => {
      if (e.keyCode === LEFT_ARROW) {
        onClickBack()
      }

      if (e.keyCode === RIGHT_ARROW) {
        onClickNext()
      }
    }

    document.addEventListener('keydown', keyDown)
    return () => {
      document.removeEventListener('keydown', keyDown)
    }
  }, [data, currentImg])

  const onClickBack = () => {
    setIsLoadingImg(true)
    setCurrentImg(currentImg === 0 ? 0 : currentImg - 1)
  }

  const onClickNext = () => {
    setIsLoadingImg(true)
    setCurrentImg(
      currentImg === data.length - 1 ? data.length - 1 : currentImg + 1,
    )
  }

  const onClickGetStarted = () => {
    service
      .updateCoachMarks({
        ScreenUrl: id || location.pathname,
      })
      .then(() => {
        setData([])
        EventEmitter.dispatch(SCROLL_DISABLE, {
          id: SCROLL_LAYOUT_ELEMENT_ID,
          disable: false,
        })
      })
  }

  const onClickLearnMore = () => {
    window.open(data[currentImg]?.learnMoreUrl, '_blank')
  }

  const onLoad = () => {
    setIsLoadingImg(false)
  }

  if (isLoading || !data.length) {
    return (
      <>
        <div className="positionRelative wh100">
          {isLoading && <Loading />}
          <div className="wh100" style={{ opacity: isLoading ? 0 : 1 }}>
            {children}
          </div>
        </div>
      </>
    )
  }

  return (
    !!data.length && (
      <div
        className={classes.container}
        style={{
          position: id ? 'fixed' : 'absolute',
          width: size.width,
          height: size.height - (!id ? top : 50),
          top: !id ? top : 50,
        }}
      >
        <div className={classes.content}>
          <div className={classes.image}>
            {isLoadingImg && <Loading />}
            <Image
              src={data[currentImg]?.url}
              alt="coach mark"
              style={{
                width: '65%',
                minWidth: 850,
                height: 'auto',
                maxHeight: '100%',
                cursor: 'default',
                visibility: isLoadingImg ? 'hidden' : 'visible',
              }}
              onLoad={onLoad}
            />
          </div>
          {currentImg !== 0 && (
            <Icon
              className={['icon-arrow-left', classes.iconArrowLeft].join(' ')}
              style={{ color: '#888888', fontSize: 40 }}
              onClick={onClickBack}
            />
          )}
          {currentImg !== data.length - 1 && (
            <Icon
              className={['icon-arrow-right', classes.iconArrowRight].join(' ')}
              style={{ color: '#888888', fontSize: 40 }}
              onClick={onClickNext}
            />
          )}
          <div className="dFlex alignItemsCenter gap1">
            {data.map((_, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: 5,
                    backgroundColor:
                      currentImg === index ? '#FFFFFF' : '#9C9C9C',
                  }}
                />
              )
            })}
          </div>
          <div className="dFlex alignItemsCenter gap2">
            <Element
              className={classes.getStartedBtn}
              style={{ fontSize: 16 }}
              onClick={onClickGetStarted}
            >
              <Translate value="coachMark.GET_STARTED" />
            </Element>
            <Element
              className={classes.learnMoreBtn}
              style={{ fontSize: 16 }}
              onClick={onClickLearnMore}
            >
              <Translate value="coachMark.LEARN_MORE" />
            </Element>
          </div>
        </div>
      </div>
    )
  )
}
